import { useCallback } from "react";
import Mask from "./Mask";
import Modal from "components/Modal";
import { createModal } from "react-modal-promise";
import styles from "./Modal.module.css";

export const MaskWithModal = ({ open, close, onSearch, ...props }) => {
    const handleSearch = useCallback(
        (...args) => {
            onSearch(...args);
            close();
        },
        [onSearch, close]
    );
    return (
        <Modal
            show={open !== false}
            onHide={close}
            dialogClassName={styles.dialog}
            backdropClassName={styles.backdrop}
            dataTest="searchMaskModal"
        >
            <Modal.Body>
                <Mask onSearch={handleSearch} {...props} />
            </Modal.Body>
        </Modal>
    );
};
MaskWithModal.displayName = "SearchMask.Modal";

const SearchMaskModal = createModal(MaskWithModal);
export default SearchMaskModal;
